import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AppErrorBoundary, setupGlobalErrorHandlers } from "./shell/crashReporter";

// Self-hosted crash reporter — installs window.onerror +
// unhandledrejection handlers that POST to /api/_telemetry/frontend-error.
// The Founder Panel's "Errors" page shows what arrives.
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);

// Service Worker — cold-boot offline support + auto-update detection.
// Registered in production builds only so dev hot-reload isn't trapped behind
// a cached bundle.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    // updateViaCache:'none' — force the browser to always revalidate the SW
    // file itself against the network. Without this, some browsers cache
    // /service-worker.js for up to 24 h, which means a deploy that bumps
    // CACHE_VERSION can go unnoticed for a day. With 'none', every page
    // load re-fetches the SW file, sees the new CACHE_VERSION, installs the
    // new SW, activates it (deleting the stale cache), and fires
    // controllerchange → we reload → the user sees the freshly-deployed
    // bundle within one page load of the deploy landing.
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' }).then((reg) => {
      // Kick an immediate update check on every page load. Belt-and-braces
      // safety net so users with long-lived tabs still pick up new deploys
      // without waiting for a fresh navigation.
      try { reg.update(); } catch { /* update() failure is non-fatal */ }
      // Detect a waiting SW (already installed by a previous tab in this profile)
      if (reg.waiting) {
        window.dispatchEvent(new CustomEvent('audinexa:sw-update-ready', { detail: reg }));
      }
      // Detect a NEW SW installing while the page is already open
      reg.addEventListener('updatefound', () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.addEventListener('statechange', () => {
          // 'installed' + an existing controller = an update is waiting to take over
          if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent('audinexa:sw-update-ready', { detail: reg }));
          }
        });
      });
    }).catch(() => { /* registration failure is non-fatal */ });

    // When the new SW activates, reload once so the page picks up the fresh bundle.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
